const firebaseConfig = {
    apiKey: "AIzaSyCwguZfxJRRVohHS-fJ39JW0xbVElIu1gc",
    authDomain: "my-doctors-portal-38b90.firebaseapp.com",
    projectId: "my-doctors-portal-38b90",
    storageBucket: "my-doctors-portal-38b90.appspot.com",
    messagingSenderId: "820073221958",
    appId: "1:820073221958:web:debd187939eb84e92e5f47"
  };
  export default firebaseConfig;

